module.exports = __webpack_public_path__ + "static/media/chatIcon.a145894d.svg";